import { notifyError } from '@config/tostifyConfig/tostifyConfig';

export const useEditHandler = ({ 
    data, 
    selectedData, 
    setSelectedItem, 
    handleOpenModal,
    modalType = 'edit', 
    errorMessage = 'No item selected for editing'
}) => {
    const handleEdit = () => {
        if (!selectedData) {
            notifyError(errorMessage);
            return;
        }

        const itemToEdit = data?.find(item => item.id === selectedData);

        if (itemToEdit) {
            setSelectedItem(itemToEdit);
            handleOpenModal(modalType);
        } else {
            notifyError('Selected item not found');
        }
    };

    return handleEdit;
};